import React from 'react';
import Healthcare from '../../../content/social-development/community-development/healthcare';
import DrinkingWater from '../../../content/social-development/community-development/drink-water';
import WomenEmp from '../../../content/social-development/community-development/women-emp';
import SkillingYouth from '../../../content/social-development/community-development/skilling-youth';
import Agriculture from '../../../content/social-development/community-development/agriculture';
import CommunityInfra from '../../../content/social-development/community-development/comm-infra';
import SportCulture from '../../../content/social-development/community-development/sports';
import EnviromentRestoration from '../../../content/social-development/community-development/envi-rest';
import AligningBusiness from '../../../content/social-development/community-development/aligning-business';
import ChildEducation from '../../../content/social-development/community-development/child-education';
import Accordion from '../../../components/accordion';
import ScrollPositionAnimation from '../../../components/scrollpositionanimation';

const CommunityDevelopment = () => {
      const sampleData = {
        accordion: [
        { id: 1, title: 'Children’s Well-being And Education', source: () =>
        <ChildEducation /> },
        { id: 2, title: 'Healthcare', source: () =>
        <Healthcare /> },
        { id: 3, title: 'Drinking Water & Sanitation', source: () =>
        <DrinkingWater /> },
        { id: 4, title: 'Women’s Empowerment', source: () =>
        <WomenEmp /> },
        { id: 5, title: 'Skilling Youth', source: () =>
        <SkillingYouth />},
        { id: 6, title: 'Agriculture & Animal Husbandry', source: () =>
        <Agriculture /> },
        { id: 7, title: 'Community Infrastructure', source: () =>
        <CommunityInfra /> },
        { id: 8, title: 'Sports & Culture', source: () =>
        <SportCulture /> },
        { id: 9, title: 'Environmental Restoration & Protection', source: () =>
        <EnviromentRestoration /> },
        ],
        };
  return (
    <div className="container-fluid remove-gradient p-t-0">
      <div className="social-development-container p-t-0 bottom-section">
        <ScrollPositionAnimation targetElement2="anim-five">
          <div className="section-inner">
              <div className="sd-accord">
                <div className="bottom-to-top anim-five">
                  <Accordion data={sampleData.accordion}></Accordion>
                </div>
              </div>
          </div>
          </ScrollPositionAnimation>
      </div>
    </div>
  );
};

export default CommunityDevelopment;
